import React, { useEffect, useState } from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";

import { DFE_STATUS_OPTIONS } from "../helpers.dfe";

export const ModalDfeFilter = ({ show, close, filters, setCustomFilters }) => {
    const [status, setStatus] = useState('');
    const [issuedFrom, setIssuedFrom] = useState('');
    const [issuedTo, setIssuedTo] = useState('');

    useEffect(() => {
        if (!show) return;

        setStatus(filters.status);
        setIssuedFrom(filters.issuedFrom);
        setIssuedTo(filters.issuedTo);
    }, [show, filters]);

    const apply = () => {
        setCustomFilters({ status, issuedFrom, issuedTo });
        close();
    };

    const clear = () => {
        setCustomFilters({ status: '', issuedFrom: '', issuedTo: '' });
        close();
    };

    return (
        <Modal
            title={`Filtrar notas recebidas`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Limpar filtros`} action={clear} />
                    <Button type={`primary`} size={`small`} text={`Aplicar`} action={apply} />
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col-12">
                        <InputSelect menuInBody label={`Situação`} options={DFE_STATUS_OPTIONS} value={status} change={setStatus} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputDate label={`Emissão de`} format={`YYYY-MM-DD`} value={issuedFrom} change={setIssuedFrom} />
                    </div>
                    <div className="col-6">
                        <InputDate label={`Emissão até`} format={`YYYY-MM-DD`} value={issuedTo} change={setIssuedTo} />
                    </div>
                </div>
                <p className={`dfe-filter-hint`}>
                    Com um período escolhido, "Atualizar lista" relê esse intervalo no provedor —
                    no máximo 31 dias por vez. Notas anteriores à ativação da busca automática não
                    existem no acervo: essas só entram pela chave de acesso.
                </p>
            </div>
        </Modal>
    );
};

export default ModalDfeFilter;
